import stringToColor from './stringToColor'

/***
 * @function stringAvatar
 * @description Extract letter to name and arr color.
 * @param {string} name: Name of peson.
 *
 * @example
 * <Avatar {...stringAvatar("Juan Carlos Gomez")} />
 */
function stringAvatar (name: string): any {
  if (name.length == 0) return 'AZ'
  return {
    sx: {
      bgcolor: stringToColor(name)
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
  }
}

export default stringAvatar
